import { render } from "./AllOptionDescription.vue?vue&type=template&id=129540e4&scoped=true"
import script from "./AllOptionDescription.vue?vue&type=script&lang=js"
export * from "./AllOptionDescription.vue?vue&type=script&lang=js"

import "./AllOptionDescription.vue?vue&type=style&index=0&id=129540e4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129540e4"]])

export default __exports__